export const REVYRE = {
  COLLECT_IQ: {
    WORKFLOW_TYPES: ['batch', 'ccase', 'loan'],
    DOMAIN_TYPES: ['activity', 'workflow', 'approval', 'payment'],
    CREATE_SCENARIO_BLOCKED_ENTITIES: ['ccase', 'loan', 'payment'],
    RESTRICT_HEADER_BUTTONS: ['loan'],
    DETAILS_PAGE_QUICK_ACTIONS_HIDDEN_RULES: {
      nonWorkflow: {
        hiddenStatuses: ['COMPLETED', 'PAYMENT_COMPLETED', 'CANCELLED'],
      },
      workflow: {
        hiddenByInputKey: 'suspended',
      },
    },
    DETAILS_PAGE_CUSTOM_REFFERED_ENTITIES: ['payment'],
    STATUS_ERROR_CODE_WITH_DESCRIPTION: [50008],
    SHOW_BULK_REASSIGN_BUTTON_IN_LIST_PAGE: ['ccase'],
  },
};

export const STATE_ID = 'stateId';
export const DISPOSITION_GROUP = 'outcomeGroup';
export const BULK_REASSIGN_MULTIMEDIA_CONFIG = [
  {
    multimedia_options: {
      media_type: 'document',
      media_types: ['document', 'photo'],
      mime_types: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
      ],
      access: ['local_storage', 'camera', 'gallery'],
      max_files: 1,
      max_size: 20 * 1024 * 1024,
    },
    templateDownloadConfig: {
      label: 'Download Template',
      url: `/vymo/v3/workflow/bulk-allocation/template`,
    },
    code: 'bulkReassign',
    hint: 'Bulk Reassign',
    type: 'multimedia',
  },
];
